import { ISelectComPesquisaProps, SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { usePessoaGeneroListar } from "@/Services/Pessoa/PessoaGeneroService";
import { Input } from "antd";

interface IPessoaGeneroSelectSelectProps extends ISelectComPesquisaProps {
    filtros?:Parameters<typeof usePessoaGeneroListar>[0];
}

export default function PessoaGeneroSelect({
    loading,
    placeholder,
    allowClear,
    filtros,
    value,
    ...rest
}:IPessoaGeneroSelectSelectProps) {
    placeholder = placeholder ?? "Selecione";
    allowClear = allowClear ?? true;
    loading = loading ?? undefined;
    filtros = filtros ?? {
        pessoaGenero : undefined,
        ativo : true
    }

    const {
        data,
        isLoading,
        isFetching
    } = usePessoaGeneroListar({
        ...filtros
    });

    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder}
        allowClear={allowClear}
        loading={isLoading || isFetching || loading}
        value={value}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    />
}